// @ts-nocheck
const isElementVisible = (element: HTMLElement) => {
    return Boolean(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
};

export default isElementVisible;
